import { Provider } from '@angular/core';
import { AbstractUserInfoService } from '../../services/abstract-user-info/abstract-user-info.service';

export const provideUserInfoService = (
    implementation?: typeof AbstractUserInfoService,
): Provider => ({
    provide: AbstractUserInfoService,
    useExisting: implementation,
});
